const extensionsByMime = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
} as const;

type Fetcher = (url: string, init?: RequestInit) => Promise<Response>;

/**
 * Foto oficial: intent autorizado → PUT binário no link de envio da API (assinado, de uso único,
 * valida conteúdo) → confirmação. O cliente nunca grava nem apaga direto no bucket privado.
 */
export async function uploadRemontaPhoto(input: {
  laudoId: string;
  file: File;
  tipoFoto: string;
  elementoId?: string;
  accessToken?: string;
  fetcher?: Fetcher;
}): Promise<void> {
  const extension = extensionsByMime[input.file.type as keyof typeof extensionsByMime];
  if (!extension) throw new Error("Tipo de foto nao permitido");
  const fetcher = input.fetcher ?? fetch;
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (input.accessToken) headers.Authorization = `Bearer ${input.accessToken}`;

  const intentResponse = await fetcher(
    `/api/remonta/laudos/${input.laudoId}/fotos/upload-intent`,
    { method: "POST", headers, body: JSON.stringify({ extensao: extension }) },
  );
  if (!intentResponse.ok) throw new Error("Erro ao preparar envio da foto");
  const intent = await intentResponse.json() as { storagePath?: string; signedUrl?: string };
  if (!intent.storagePath || !intent.signedUrl?.startsWith("/api/uploads/")) {
    throw new Error("Resposta de upload invalida");
  }

  const upload = await fetcher(intent.signedUrl, {
    method: "PUT",
    headers: { "Content-Type": input.file.type },
    body: input.file,
  });
  if (!upload.ok) throw new Error("Erro ao enviar foto");

  // Sem confirmação o objeto fica órfão (sem registro), mas nunca é apagado pelo cliente:
  // outro fluxo pode já referenciá-lo e o bucket não aceita DELETE do browser.
  const confirmation = await fetcher(`/api/remonta/laudos/${input.laudoId}/fotos`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      storagePath: intent.storagePath,
      tipoFoto: input.tipoFoto,
      ...(input.elementoId ? { elementoId: input.elementoId } : {}),
    }),
  });
  if (!confirmation.ok) throw new Error("Erro ao registrar foto");
}
